import { useState, useEffect } from 'react';
import { FcTodoList } from 'react-icons/fc'
import { IoMdAddCircleOutline } from 'react-icons/io'
import { TiDeleteOutline } from 'react-icons/ti'
import { auth, firestore } from './firebase';
import firebase from 'firebase';
import { useCollectionData } from 'react-firebase-hooks/firestore'
import { toast } from 'react-toastify';

const Todos = () => {
  const todosRef = firestore.collection(`users/${auth.currentUser.uid}/todos`);
  const [count, setCount] = useState(0);
  const [todos, loading] = useCollectionData(todosRef.orderBy('completed'), { idField: 'id' });

  useEffect(() => {
    let tempCount = 0;
    todos?.forEach((todo) => !todo.completed && ++tempCount);
    setCount(tempCount)
  }, [todos]);

  return (
    <div className="Todo-card">
      <nav>
        <button style={{ height: '2rem', pading: '0.2rem 1rem' }} className="App-button" onClick={() => auth.signOut()}>Logout</button>
      </nav>
      <div className="App-header">
        <h2><FcTodoList style={{ position: "relative", top: "0.5rem", paddingRight: "0.25rem" }} />Todos</h2>
        <span>{count} remaining</span>
      </div>
      <AddTdo todosRef={todosRef} />
      <div className="List-view">
        {loading ? 'Loading...' : todos && todos.map((todoItem) => (
          <Todo key={todoItem.id} {...todoItem} />
        ))}
      </div>
    </div>
  );
}

export default Todos;

const AddTdo = ({ todosRef }) => {
  const [task, setTask] = useState("");
  const onSubmit = (event) => {
    event.preventDefault();

    if (task === '') return;

    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    todosRef.add({
      task,
      completed: false,
      createdAt,
      updatedAt: createdAt,
    }).then(value => console.log(value)).catch(err => console.log(err)).finally(() => setTask(''))
  };
  return (
    <form className="Input-container">
      <input className="Input-field App-border-radius" placeholder="Add task" type="text" value={task} onChange={(e) => setTask(e.target.value)} />
      <button type="submit" onClick={onSubmit} className="App-button Add-button App-border-radius">Add <IoMdAddCircleOutline size={20} style={{ verticalAlign: "middle" }} /></button>
    </form>
  );
};

const Todo = ({ id, completed, task }) => {
  const [todo, setTodo] = useState(task);
  const todosRef = firestore.collection(`users/${auth.currentUser.uid}/todos`);

  const onEditTodo = (id, task) => {
    todosRef.doc(id).set({ task: task, updatedAt: firebase.firestore.FieldValue.serverTimestamp() }, { merge: true }).then(() => toast.info('Task Updated!'))
  };

  const onCompleteTodo = (id, completed) => {
    todosRef.doc(id).set({ completed: !completed, updatedAt: firebase.firestore.FieldValue.serverTimestamp() }, { merge: true }).then(() => {
      if (completed) {
        toast.info('Marked as incomplete');
      } else {
        toast.success('Marked as completed!!');
      }
    });
  }

  const onDeleteTodo = () => {
    todosRef.doc(id).delete().then(() => toast.warning('Task deleted!'));
  };

  return <div key={id} className="List-tile App-border-radius">
    <input checked={completed} className="List-tile-leading" type="checkbox" onChange={(e) => {
      e.preventDefault();
      onCompleteTodo(id, completed);
    }} />
    <input style={{
      width: '100%',
      height: '1.75rem',
      fontSize: '1.5rem',
      background: 'transparent',
      border: '0.02rem solid black',
      borderRadius: 8,
      paddingLeft: 8
    }} value={todo} onChange={(e) => {
      const { value } = e.target;
      setTodo(value);
    }} />
    {task !== todo && <button onClick={() => onEditTodo(id, todo)} className="Todo-update-submit">save</button>}
    <TiDeleteOutline className="List-tile-trailing" onClick={onDeleteTodo} />
  </div>;
};
